import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ErrorMsgService } from '../../../common/error-msg.service';

@Component({
    selector: 'aa-validation-manual',
    templateUrl: './validation-manual.component.html',
    styleUrls: [
        '../validation2/validation2.component.scss'
    ],
    standalone: false
})
export class ValidationManualComponent implements OnInit, OnChanges
{
    private keys: string[] = [
        'LACKOFQUOTA',
        'REQUIRED'
    ];
    @Input() formField: AbstractControl;
    @Input() dirty: boolean;
    public message: string;

    constructor(private errorMsgService: ErrorMsgService)
    {
    }

    ngOnInit ()
    { }

    ngOnChanges (simpleChanges: SimpleChanges): void
    {
        const dirty: boolean = simpleChanges.dirty.currentValue;

        this.message = undefined;
        if (dirty)
        {
            this.keys.every((key: string) =>
            {
                if (this.formField.getError(key))
                {
                    this.message = this.errorMsgService.getMessage(null, key);

                    return false;
                }
            });
        }
    }
}
